import { CallState } from "redmond";
import { put } from "redux-saga/effects";
import {
  fetchUserPassengers,
  IListUserPassengersResponse,
} from "../../../../api/v0/user-passengers/fetchUserPassengers";
import { actions } from "../../actions";

export function* fetchUserPassengersSaga(_: actions.IFetchUserPassengers) {
  try {
    const userPassengers: IListUserPassengersResponse =
      yield fetchUserPassengers({});

    yield put(
      actions.setUserPassengers({
        userPassengerCallState: CallState.Success,
        userPassengers,
      })
    );
  } catch (e) {
    yield put(actions.setUserPassengersCallState(CallState.Failed));
  }
}
